import React, { useEffect, useState } from "react";
import { LogoHorizontal } from "./Logo";
import { Menu, X } from "lucide-react";
import { waLink } from "../lib/site";

const nav = [
  { label: "Sobre", href: "#sobre" },
  { label: "Benefícios", href: "#beneficios" },
  { label: "Como Funciona", href: "#como-funciona" },
  { label: "Para Quem", href: "#para-quem" },
  { label: "FAQ", href: "#faq" },
  { label: "Contato", href: "#contato" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-40 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-2xl bg-[#05070D]/80 border-b border-white/5"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-20">
        <a href="#top" data-testid="header-logo-link" className="shrink-0">
          <LogoHorizontal />
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {nav.map((item) => (
            <a
              key={item.href}
              href={item.href}
              data-testid={`nav-link-${item.href.slice(1)}`}
              className="text-[12.5px] tracking-[0.18em] uppercase text-[#A3ABB8] hover:text-[#D4AF37] transition-colors duration-300"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:block">
          <a
            href={waLink()}
            target="_blank"
            rel="noreferrer"
            data-testid="header-cta-whatsapp"
            className="inline-flex items-center gap-2 text-[11.5px] tracking-[0.2em] uppercase border border-[#D4AF37]/60 text-[#D4AF37] hover:bg-[#D4AF37] hover:text-[#05070D] px-5 py-3 transition-all duration-300"
          >
            Falar no WhatsApp
          </a>
        </div>

        <button
          aria-label="Abrir menu"
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden text-[#D4AF37] p-2"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile drawer */}
      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden border-t border-white/5 bg-[#05070D]/95 backdrop-blur-xl"
        >
          <div className="px-6 py-6 flex flex-col gap-5">
            {nav.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${item.href.slice(1)}`}
                className="text-sm tracking-[0.18em] uppercase text-[#A3ABB8] hover:text-[#D4AF37]"
              >
                {item.label}
              </a>
            ))}
            <a
              href={waLink()}
              target="_blank"
              rel="noreferrer"
              data-testid="mobile-cta-whatsapp"
              className="mt-2 inline-flex items-center justify-center gap-2 text-xs tracking-[0.2em] uppercase bg-[#D4AF37] text-[#05070D] px-5 py-3"
            >
              Falar no WhatsApp
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
